var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export const HorizontalScrollableBox = React.forwardRef((_a, ref) => {
    var _b, _c;
    var { children } = _a, props = __rest(_a, ["children"]);
    const containerRef = React.createRef();
    const topRef = React.createRef();
    //const viewRef = React.createRef<HTMLDivElement>();
    const viewRef = React.useMemo(() => ref, [ref]);
    const bottomRef = React.createRef();
    const scroll = (e) => {
        var _a;
        let target = e.currentTarget;
        if (!target)
            return;
        if (viewRef === null || viewRef === void 0 ? void 0 : viewRef.current)
            viewRef.current.scrollLeft = target.scrollLeft;
        if (topRef === null || topRef === void 0 ? void 0 : topRef.current)
            topRef.current.scrollLeft = target.scrollLeft;
        if (bottomRef === null || bottomRef === void 0 ? void 0 : bottomRef.current)
            bottomRef.current.scrollLeft = target.scrollLeft;
        let sticky = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('stickyTable')[0];
        if (sticky)
            sticky.scrollLeft = target.scrollLeft;
    };
    //React.useEffect(() => {
    //    if (!containerRef?.current)
    //        return;
    //    for (let i = 0; i < containerRef.current.children.length; i++) {
    //        let e = containerRef.current.children[i] as HTMLElement
    //        if (e === topRef?.current || e === viewRef?.current || e === bottomRef?.current)
    //            continue;
    //        e.removeEventListener('scroll', scroll)
    //        e.addEventListener('scroll', scroll)
    //    }
    //}, [containerRef?.current?.children?.length, topRef?.current, viewRef?.current, bottomRef?.current])
    //React.useEffect(() => {
    //    if (!containerRef.current)
    //        return;
    //    //containerRef.current.addEventListener('scroll', scroll)
    //    //window.addEventListener('scroll', scroll)
    //}, [containerRef.current])
    React.useEffect(() => {
        if (props.onLoad)
            props.onLoad(scroll);
    }, []);
    return (React.createElement("div", { ref: containerRef, onLoad: () => {
            if (props.onLoad)
                props.onLoad(scroll);
        } },
        props.topVisible === false ? null : React.createElement("div", { className: "wmd-view-topscroll", ref: topRef, onScroll: scroll },
            React.createElement("div", { className: "scroll-div", style: { width: (_b = viewRef === null || viewRef === void 0 ? void 0 : viewRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth } }, "\u00A0")),
        React.createElement("div", { className: "wmd-view", ref: viewRef, onScroll: scroll },
            React.createElement("div", { className: "dynamic-div" }, children({ scroll }))),
        props.bottomVisible === false ? null : React.createElement("div", { className: "wmd-view-bottomscroll", ref: bottomRef, onScroll: scroll },
            React.createElement("div", { className: "scroll-div", style: { width: (_c = viewRef === null || viewRef === void 0 ? void 0 : viewRef.current) === null || _c === void 0 ? void 0 : _c.scrollWidth } }, "\u00A0"))));
});
